export default __webpack_public_path__ + "static/media/zoom-logo.4a3f980e.png";